import { render, staticRenderFns } from "./classSure.vue?vue&type=template&id=4350465b&scoped=true"
import script from "./classSure.vue?vue&type=script&lang=js"
export * from "./classSure.vue?vue&type=script&lang=js"
import style0 from "./classSure.vue?vue&type=style&index=0&id=4350465b&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4350465b",
  null
  
)

export default component.exports